import { render } from "./OrderRecord.vue?vue&type=template&id=0e1d1e75&scoped=true"
import script from "./OrderRecord.vue?vue&type=script&lang=js"
export * from "./OrderRecord.vue?vue&type=script&lang=js"

import "./OrderRecord.vue?vue&type=style&index=0&id=0e1d1e75&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1d1e75"]])

export default __exports__